const $ = require('jquery');

const optiTracking = require('./optimizely');

const EVENTS_TYPES = {
    LOGIN: 'login',
    LOG_OUT: 'log_out',
    UPDATE_ACCOUNT: 'update_account',
    DELETE_ACCOUNT: 'delete_account',
    FORGOT_PASSWORD: 'forgot_password'
};

/**
 * Pushes an account event to the dataLayer
 *
 * @param {string} eventType - Event type
 * @returns {void}
 */
function pushEventToDataLayer(eventType) {
    if (!window.dataLayer) {
        return;
    }

    const event = {
        event: 'ga4_event',
        event_name: eventType
    };

    window.dataLayer.push(event);
}

/* eslint-disable import/prefer-default-export */
/**
 * Initializes account events
 *
 * @returns {void}
 */
export const init = () => {
    $('body').on('submit', '#RegistrationForm, #ChangeEmailForm, #ChangePasswordForm, #addressform', function (e) {
        const isRegistrationPage = $(e.target).find('[name$=customer_regsource]').length;

        if (!$(this).valid() || isRegistrationPage) {
            return;
        }

        pushEventToDataLayer(EVENTS_TYPES.UPDATE_ACCOUNT);
    });

    $('body').on('click', '.address-delete', () => {
        pushEventToDataLayer(EVENTS_TYPES.UPDATE_ACCOUNT);
    });

    $('body').on('submit', '#DeleteAccountForm', function () {
        if (!$(this).valid()) {
            return;
        }

        pushEventToDataLayer(EVENTS_TYPES.DELETE_ACCOUNT);
    });

    const trackSuccessfullyRegister = $('body').find('input[name="trackSuccessfullyRegister"]')[0];

    if (trackSuccessfullyRegister && trackSuccessfullyRegister.value) {
        optiTracking.pushEventToOptimizely('MEMBERSHIP');
    }
};
